import React, { memo, useCallback } from "react";
import useMessageThreadDraft from "modules/hooks/use-message-thread-draft";
import { TaskDueDateOption } from "modules/utils/Constants";
import DueDateSelector from "./_shared/due-date-selector";

interface IProps {
  draftId: string;
}

const TaskDueDateSelector: React.FC<IProps> = ({ draftId }: IProps) => {
  const { draft, setTask } = useMessageThreadDraft({
    draftId,
  });

  const onDateChanged = useCallback(
    (option: TaskDueDateOption, dueTime: string | null) => {
      if (!draft || !draft.task) {
        return;
      }
      setTask({
        ...draft.task,
        dueDateOption: option,
        dueTime,
      });
    },
    [draft, setTask],
  );

  const onDateCleared = useCallback(() => {
    if (!draft || !draft.task) {
      return;
    }
    setTask({
      ...draft.task,
      dueDateOption: undefined,
      dueTime: null,
    });
  }, [draft, setTask]);

  if (!draft) return null;

  return (
    <DueDateSelector
      dueTime={draft.task?.dueTime}
      taskDueDateOption={draft.task?.dueDateOption}
      onDateChanged={onDateChanged}
      onDateCleared={onDateCleared}
    />
  );
};

export default memo(TaskDueDateSelector);
